import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ngxui-status-bar-right',
    templateUrl: './status-bar-right.component.html',
    styleUrls: ['./status-bar-right.component.scss']
})
export class StatusBarRightComponent implements OnInit {
    @Input() ShowNotification: boolean = false;
    @Output() NotificationEvent = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    onNotification(event) {
        event.preventDefault();
        this.NotificationEvent.emit();
    }
}
